export default __webpack_public_path__ + "static/media/awesome-paper-plane.0c4c1ad6.svg";